export default __webpack_public_path__ + "static/media/deco_white_logo.7f7ca7cd.png";